module.exports = __webpack_public_path__ + "img/동대입구역 카페.88e07a7a.png";